import styles from "./acardeon.module.css";
import { useMeals, useMealsAction } from "../../../../Context/MealsProvider";

import { AiOutlinePlus } from "react-icons/ai";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const Acardeon = ({ index, dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();

  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}-${dayIndex}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div>
      <p>
        <button
          className={`btn ${styles.btnacardeon}`}
          type="button"
          onClick={toggleAccordion}
        >
          <AiOutlinePlus />
        </button>
      </p>
      <div className="collapse" id={`accordion-${index}-${dayIndex}`}>
        <div style={{ marginTop: "22px" }}>
          <div className={styles.containerAcardeon}>
            <div className={styles.containerMain}>
              <div className={styles.formInput}>
                <p className={styles.text}>ترنسفر</p>
                <select
                  class="form-select form-select-sm"
                  aria-label=".form-select-sm example"
                  className={styles.inputBox}
                  value={meals[dayIndex][8].vehValue}
                  onChange={(e) =>
                    dispatch({
                      day: dayIndex,
                      type: "changeHandlerVehicle",
                      id: 8,
                      event: e,
                    })
                  }
                >
                  <option
                    selected
                    hidden
                    disabled
                    className={styles.selected}
                  ></option>
                  <option value="endividual" className={styles.cnterItem}>
                    انفرادی
                  </option>
                  <option value="group">گروهی</option>
                </select>
              </div>

              {meals[dayIndex][8].vehValue == "group" && (
                <div className={styles.formInput}>
                  <p className={styles.text}>ظرفیت</p>
                  <input
                    type="text"
                    className={styles.inputBox}
                    value={addCommas(meals[dayIndex][index].capacity)}
                    onChange={(e) =>
                      dispatch({
                        type: "changeHandlerCapacity",
                        day: dayIndex,
                        id: index,
                        event: e,
                      })
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Acardeon;
